// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colForm{padding-left:5px!important;padding-right:5px!important;padding-top:5px!important;padding-bottom:5px!important}.fade-enter-active,.fade-leave-active{transition:opacity .6s}.fade-enter,.fade-leave-to{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
